import React from "react";
import Style from "./Warning.module.css";
import { GoBlocked } from "react-icons/go";

const DeactiveLogin = ({ onClose }) => {
  return (
    <div className={Style.WarningdeleteConfirmation}>
      <div className={Style.WarningconfirmationCard}>
        <>
          <div className={Style.WarningiconContainer}>
            <GoBlocked size={50} color="red" />
          </div>

          <h3>Your account has been deactivated</h3>
          <p className={Style.Warrningpara}>
            {" "}
            You can no longer access your account. Please contact support if
            this is a mistake.
          </p>

          <div className={Style.WarningbuttonGroup}>
            <button className={`${Style.WarningdeleteBtn} `} onClick={onClose}>
              Done
            </button>
          </div>
        </>
      </div>
    </div>
  );
};

export default DeactiveLogin;
